import Vue from 'vue'
import BaseComponent from '@base/component'

var $ = window.jQuery;
var ComboCalculatorVue = Vue.extend({
    mixins: [ BaseComponent ],
    props: ['mdl'],
    data: function() {
	$(document.body).on("choose_product", (evt:any, id:any, idkey:any) => (this as InstanceType<typeof ComboCalculatorVue>).chooseProduct(evt, id, idkey));
        return {
            model: this.mdl,
            combos: {}
        };
    },
    methods: {
        attachEvents: function() {
	    $(this.el).click((evt:any) => {
	        $(this.el).toggleClass("exp");
	    });
        },
        chooseProduct: function(evt:any, id:string, idkey:string) {
	    this.combos[idkey] = id;
	    var ids = [];
	    for (var k in this.combos) {
	        if (k == "action") continue;
	        ids.push(this.combos[k]);
	    }
	    var data:any = {ids: ids.join(","), action: "nutrition_model"};
	    data.label = this.model.get("label");
	    $.ajax({url:'/wp-admin/admin-ajax.php', data: data, success: (mdl:any) => this.chooseProductDone(mdl), error: (xhr:any, txt:string) => this.failureFn(xhr, txt), dataType: "json"});
        },
        failureFn: function() {
	    console.error("failureFn ",arguments);
        },
        chooseProductDone: function(mdl:any) {
	    mdl.itemName.show = false;
	    mdl.disclaimer.show = false;
	    mdl.ingredientList.show = false;	    
	    this.model.set(mdl);
        }
    }
});

export default ComboCalculatorVue;
